import React from 'react';

type DisplaySize = 'hero' | 'section' | 'sub-section' | 'section-large' | 'pull-quote';

interface DisplayHeadingProps {
  size: DisplaySize;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'blockquote';
  className?: string;
  id?: string;
  children: React.ReactNode;
}

const SIZE_STYLES: Record<DisplaySize, React.CSSProperties> = {
  hero: { fontSize: 'clamp(56px, 7vw, 104px)', lineHeight: 0.95 },
  section: { fontSize: 'clamp(40px, 5vw, 64px)', lineHeight: 1.0 },
  'sub-section': { fontSize: '32px', lineHeight: 1.05 },
  'section-large': { fontSize: 'clamp(44px, 5.5vw, 72px)', lineHeight: 0.95 },
  'pull-quote': { fontSize: 'clamp(32px, 3.5vw, 52px)', lineHeight: 1.1, fontStyle: 'italic' },
};

const DisplayHeading: React.FC<DisplayHeadingProps> = ({
  size,
  as: Tag = 'h2',
  className = '',
  id,
  children,
}) => {
  const base = 'font-we-display font-black tracking-[-0.025em]';
  return (
    <Tag id={id} className={`${base} ${className}`.trim()} style={SIZE_STYLES[size]}>
      {children}
    </Tag>
  );
};

export default DisplayHeading;
